import { render, staticRenderFns } from "./C1TaskCalendar.component.vue?vue&type=template&id=bb4d2e98&"
import script from "./C1TaskCalendar.component.vue?vue&type=script&lang=js&"
export * from "./C1TaskCalendar.component.vue?vue&type=script&lang=js&"
import style0 from "./C1TaskCalendar.component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports